exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-banks-tsx": () => import("./../../../src/pages/banks.tsx" /* webpackChunkName: "component---src-pages-banks-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-privacy-policy-tsx": () => import("./../../../src/pages/privacy-policy.tsx" /* webpackChunkName: "component---src-pages-privacy-policy-tsx" */),
  "component---src-templates-bank-tsx": () => import("./../../../src/templates/bank.tsx" /* webpackChunkName: "component---src-templates-bank-tsx" */)
}

